import { Controller } from "@hotwired/stimulus"

// Recarrega un Turbo Frame amb l'URL de la plantilla, substituint «:id» per
// l'id rebut a l'esdeveniment (p. ex. combobox:change).
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  reload(event) {
    this.frameTarget.src = this.urlValue.replace(":id", encodeURIComponent(event.detail.id))
  }
}
